import React from 'react';
import { useT } from '../../../../../helpers/i18n';
import Table from 'react-bootstrap/Table';
import { faMap as farMap } from '@fortawesome/pro-regular-svg-icons';
import { faCar as fasCar, faPersonWalking as fasPersonWalking } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Checkers from '../../../../../helpers/class/Checkers';

function ModalPois ( props ) {
  const t = useT();

  const map_pois = props.map_pois
  return (
    <div className="modal-body">
        {
            props.descAreaDistances ?
                <>
                    <div className="row">
                        <div className="col-12">

                            <div dangerouslySetInnerHTML={{__html: props.descAreaDistances}}/>
                        </div>
                    </div>
                </>
                :
                <></>
        }
        {
        Checkers.isValidArray( map_pois ) &&
          <div className="row">
            <div className="col-12">
              <Table hover responsive>
                <thead>
                  <tr>
                    <th>{t('poi.name')}</th>
                    <th>{t('poi.type')}</th>
                    <th>{t('poi.distance')}</th>
                    <th>{t('poi.directions')}</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    map_pois.map( ( item ) => (
                      <tr key={item.property_poi_id.toString()}>
                        <td>
                          {item.property_poi_title}
                        </td>
                        <td className="px-2 py-3">
                          {item.property_poi_type}
                        </td>
                        <td className="px-2 py-3">
                          {
                            item.property_poi_selected_distance == 'drive' &&
                              <>
                                {
                                  item.property_poi_drive_distance_in_km > 0 ?
                                    <>{item.property_poi_drive_distance_in_km}km {item.property_poi_drive_time != null ? '- ' + item.property_poi_drive_time + 'min' : ''} </>
                                    : item.property_poi_drive_distance_in_meters > 0 &&
                                          <>{item.property_poi_drive_distance_in_meters}m {item.property_poi_drive_time != null ? '- ' + item.property_poi_drive_time + 'min' : ''}</>
                                }
                                <FontAwesomeIcon icon={fasCar} className="text-master ms-1"/>
                              </>
                          }
                          {
                            item.property_poi_selected_distance == 'walk' &&
                              <>
                                {
                                  item.property_poi_walk_distance_in_km > 0 ?
                                    <>{item.property_poi_walk_distance_in_km}km {item.property_poi_walk_time != null ? '- ' + item.property_poi_walk_time + 'min' : ''}</>
                                    : item.property_poi_walk_distance_in_meters > 0 &&
                                          <>{item.property_poi_walk_distance_in_meters}m {item.property_poi_walk_time != null ? '- ' + item.property_poi_walk_time + 'min' : ''}</>
                                }
                                <FontAwesomeIcon icon={fasPersonWalking}
                                  className="text-master ms-1"/>
                              </>
                          }
                          {/*
                              {
                                  item.property_poi_selected_distance == 'custom' && item.property_poi_custom_direction != null &&
                                      <div>
                                          <FontAwesomeIcon icon={farMap} className="text-master"/>
                                      </div>
                              }
                          */}
                        </td>
                        <td className="px-2 py-3 text-center">
                          {
                            item.property_poi_custom_direction != null ?
                              <a rel="noreferrer" href={item.property_poi_custom_direction} target="_blank">
                                <FontAwesomeIcon icon={farMap}/> {t('poi.directions')}
                              </a>
                              :
                              <a rel="noreferrer"
                                href={'https://www.google.com/maps/dir/'+item.property_poi_latitude+','+item.property_poi_longitude+'/'+props.property_lat+','+props.property_lng}
                                target="_blank"
                              >
                                <FontAwesomeIcon icon={farMap}/> {t('poi.directions')}
                              </a>
                          }
                        </td>
                      </tr>
                    ) )
                  }

                </tbody>

              </Table>
            </div>
          </div>
        }
    </div>
  )
}
export default ModalPois;
